import api from "../..";
import type { ApiResponse } from "../../types";
import {
  TOP_ENDPOINT,
  CONTENT_ENDPOINTS,
  normalizeContentBanner,
  type ContentBannerRaw,
  type ContentType,
  type TopBanner,
  type ContentBanner,
} from "./types";

export const getTopBanners = async (): Promise<TopBanner[]> =>
  await api
    .get<ApiResponse<TopBanner[]>>(TOP_ENDPOINT)
    .then((res) => res.data?.data ?? [])
    .catch(() => []);

export const getContentBanners = async (
  type: ContentType,
): Promise<ContentBanner[]> =>
  await api
    .get<ApiResponse<ContentBannerRaw[]>>(CONTENT_ENDPOINTS[type])
    .then((res) => (res.data?.data ?? []).map(normalizeContentBanner(type)))
    .catch(() => []);
